import { AppContext } from 'context/AppContextProvider';
import { LOGOUT_EVENT } from 'hooks/useLogout';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getFirstAllowedRoute } from 'routes/routeUtils';
import { IRouteProps } from 'routes/types';

export const useAppRouting = (routes: IRouteProps[]) => {
    const [isLogged, setIsLogged] = useState<boolean>(() => !!sessionStorage.getItem("token"));
    const [isLoaded, setIsLoaded] = useState(false);
    
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { isRouteAllowed } = useContext(AppContext);

    const isCurrentRouteProtected = (allRoutes: IRouteProps[]): boolean | undefined => {
        for (const route of allRoutes) {
            if (route.route === pathname) {
                return !!route.protected;
            }
            if (route.collapse && route.collapse.length > 0) {
                const nested = isCurrentRouteProtected(route.collapse);
                if (nested !== undefined) return nested;
            }
        }
        return undefined;
    };

    useEffect(() => {
        const token = sessionStorage.getItem("token");

        if (!token) {
            setIsLogged(false);
        } else {
            setIsLogged(true);
            if (isCurrentRouteProtected(routes) === false) {
                const target = getFirstAllowedRoute(routes, isRouteAllowed);
                if (target) {
                    navigate(target, { replace: true });
                }
            }
        }

        setIsLoaded(true);
    }, [pathname]);

    useEffect(() => {
        const handleLogout = () => setIsLogged(false);
        window.addEventListener(LOGOUT_EVENT, handleLogout);
        return () => window.removeEventListener(LOGOUT_EVENT, handleLogout);
    }, []);

    return { isLogged, isLoaded };
};